import React from 'react';
import Avatar from '@mui/material/Avatar'
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IntlMessages from 'util/IntlMessages';
import config from '../../config';
import {userSignOut} from 'actions/Auth';
import {connect} from 'react-redux'
import { Button } from '@mui/material';

class UserInfo extends React.Component {

  state = {
    anchorEl: null,
    open: false,
  };

  handleClick = event => {
    this.setState({open: true, anchorEl: event.currentTarget});
  };

  handleRequestClose = () => {
    this.setState({open: false});
  };
  componentDidMount = ()=>{
  // //console.log("buraya geldiii", this.props)
  }

  render() {
   ////console.log("buraya geldiii 2 ", this.props)
    return (
      <div className="user-profile d-flex flex-row align-items-center">
        {
          this.props.user &&     <Avatar
          alt='...'
          src={config.userAuthApiUrl + this.props.user.profileImageUrl}
          className="user-avatar "
        />
        }
    
        <div className="user-detail">
          <h4 className="user-name" onClick={this.handleClick}> {this.props.userName}<i
            className="zmdi zmdi-caret-down zmdi-hc-fw align-middle"/>
          </h4>
          <Button variant="text"  onClick={ ()=>this.props.userSignOut()}>
          <i className="zmdi zmdi-sign-in zmdi-hc-fw mr-2"/> Çıkış Yap
          </Button>
        </div>
      
      </div>
    );
  }
} 

const mapStateToProps = (state) => {
// //console.log("stateeeee userinfoo : ",state)
  const locale = state.settings.locale;
  const userName = state.auth.authUser !== null ?  state.auth.authUser.name + ' '+state.auth.authUser.surname : null;
  const user = state.auth.authUser;
  return {locale , userName ,user}
};
export default connect(mapStateToProps, {userSignOut})(UserInfo);

